export enum BillResgisterRepsonseType {
  REGISTERED_BILL = 'Registered bill',
  LABEL_EXISTS = 'Label already exists',
  SERVICE_NAME_REGISTERED = 'Service name already registered',
  SERVICE_NAME_INCORRECT = 'Service name is incorrect',
  LATEST_TOTAL_INCORRECT = 'Latest total is incorrect',
  RPU_INCORRECT = 'RPU is incorrect',
  CFE_CONTIGO_UNAVAILABLE = 'CFE contigo page is unavailable',
  CFE_ADD_SERVICE_UNAVAILABLE = 'CFE contigo add service unavailable',
  NO_CREDENTIALS = 'Could not fetch account credentials',
}
